<template>
    <span>
        <kgr-icon-visible-in-exchange-directory
            class="icon-positioning"
            :class="{'icon-active': showData}"
            :small="small"
            accent
            :title="showData ? $t('Diese Datei ist im Datenaustausch-Ordner freigegeben, zum Deaktivieren bitte klicken.') : $t('Diese Datei ist nicht im Datenaustausch-Ordner freigegeben, zum Aktivieren der Freigabe bitte klicken.')"
            @click="toggle"
        />
    </span>
</template>

<script>

import KgrIconVisibleInExchangeDirectory from '../../components/common/icon/IconVisibleInExchangeDirectory.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-icon-visible-in-exchange-directory': KgrIconVisibleInExchangeDirectory,
    },
    props: {
        fileId: {
            type: Number,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            showData: false,
        }
    },
    mounted() {
        this.showData = this.show;
    },
    watch: {
        show(newVal) {
            this.showData = newVal;
        }
    },
    methods: {
        toggle() {
            axios
                .put('/letters/' + this.fileId + '/exchange-directory-visibility')
                .then(response => {
                    this.showData = response.data.newValue;
                    this.$emit('change', response.data.newValue);
                    this.$notify.success('letter.visibility.toggle.success.' + (response.data.newValue ? 'visible' : 'hidden'));
                })
                .catch(() => this.$notify.error('letter.visibility.toggle.error'));
        },
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.icon-positioning {
    position: relative;
    top: 2px;
}
.icon-active {
    color: green;
}
</style>
